<script>
export default {
    props: ['data'],
    name: "aboutMoreSwiper",
    data() {
        return {
            swiperOptions: {
                observer: true,
                observeParents: true,
                simulateTouch: false,
                loop: false,
                // autoplay: {
                //     delay: 5000,
                //     disableOnInteraction: false,
                // },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                pagination: {
                    el: '.swiper-pagination',
                },
            },
        };
    },
    computed: {},
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <div class="about_more_swiper">
        <swiper class="swiper" ref="mySwiper" :options="swiperOptions">
            <swiper-slide v-for="(item, index) in data.list" :key="index">
                <div class="layout_bg bg" :style="`background-image: url(${item.image});`"></div>
                <div class="content">
                    <div class="layout_main wrapper text_shadow">
                        <div class="bottom">
                            <div class="name" v-if="item.name">{{ item.name }}</div>
                            <div class="btn" v-if="item.link"><a :href="item.link">{{ item.link_name }}</a></div>
                        </div>
                    </div>
                </div>
            </swiper-slide>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
            <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
        <div class="content">
            <div class="layout_main wrapper type1 text_shadow flex flex_column justify_center">
                <div class="title">{{ data.name }}</div>
                <div class="desc" v-html="$textToHtml(data.desc)"></div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.about_more_swiper{
    height: 7.5rem;
    position: relative;
    color: #fff;
    @media only screen and (max-width: 750px) {
        height: 10.64rem;
    }
    &:nth-of-type(2n){
        .content{
            text-align: right;
            .bottom{
                right: auto;
                left: 0;
                align-items: flex-start;
            }
            @media only screen and (max-width: 750px) {
                text-align: center;
                .bottom{
                    align-items: center;
                }
            }
        }
    }
    .swiper,
    .content{
        width: 100%;
        height: 100%;
    }
    .content{
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        pointer-events: none;
        @media only screen and (max-width: 750px) {
            text-align: center;
        }
        .wrapper{
            height: 100%;
            gap: .4rem;
            position: relative;
            @media only screen and (max-width: 750px) {
                // padding-top: 5.4rem;
                width: 100%;
                position: absolute;
                height: auto;
                bottom: 1rem;
                &.type1{
                    bottom: 50%;
                }
            }
        }
        .title{
            font-size: .3rem;
            pointer-events: auto;
            @media only screen and (max-width: 750px) {
                font-size: .48rem;
            }
        }
        .desc{
            font-size: .24rem;
            pointer-events: auto;
            @media only screen and (max-width: 750px) {
                font-size: .28rem;
                padding: 0 1rem;
                /deep/br{
                    display: none;
                }
            }
        }
        .name{
            font-size: .24rem;
        }
        .btn{
            font-size: .18rem;
            a{
                border-bottom: 1px solid #fff;
            }
        }
        .bottom{
            position: absolute;
            right: 0;
            bottom: .8rem;
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            gap: .3rem;
            pointer-events: auto;
            @media only screen and (max-width: 750px) {
                position: relative;
                right: auto;
                bottom: auto;
                top: 0;
                align-items: center;
                gap: .3rem;
            }
        }
    }
    --swiper-navigation-color: #fff;/* 单独设置按钮颜色 */
    --swiper-navigation-size: .3rem;/* 设置按钮大小 */
    .swiper-button-prev,
    .swiper-button-next{
        &.swiper-button-disabled{
            opacity: 0;
        }
        @media only screen and (max-width: 750px) {
            display: none;
        }
    }
    .swiper-button-prev{
        left: 2.1rem;
    }
    .swiper-button-next{
        right: 2.1rem;
    }
    .swiper-pagination{
        display: flex;
        justify-content: center;
        gap: .1rem;
        bottom: .6rem;
        display: none;
        @media only screen and (max-width: 750px) {
            display: flex;
        }
        /deep/ .swiper-pagination-bullet{
            opacity: 1;
            margin: 0;
            width: .12rem;
            height: .12rem;
            background: none;
            border: 1px solid #fff;
            &-active{
                background: #fff;
            }
            @media only screen and (max-width: 750px) {
                width: .14rem;
                height: .14rem;
            }
        }
    }
}
</style>